import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import { CustomInput } from "../Common/CustomInput";
import axiosInstance from "../../utils/config/config";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmationSnackbar, ErrorSnackbar } from "../Common/CustomSnackbar";
import { getUserById } from "../../redux/actions/user.dispatcher";

const EmailVerification = ({ setStep }) => {
  const dispatch = useDispatch();
  const [codeSent, setCodeSent] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const { userData } = useSelector((state) => state.user);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [success, setSuccess] = useState(false);

  const handleSendCode = async () => {
    try {
      const codeSendResponse = await axiosInstance.put(`/user/sendOTP`, {
        userId: userData.id,
      });

      if (codeSendResponse) {
        setCodeSent(true);
      }
    } catch (err) {
      console.log(err);
      setErrorState({
        error: true,
        message: "Error sending verification code.",
      });
    }
  };

  const handleVerify = async () => {
    try {
      const codeSendResponse = await axiosInstance.put(`/user/verifyEmail`, {
        userId: userData.id,
        OTP: verificationCode,
      });

      if (codeSendResponse.status == 200) {
        // await dispatch(getUserById(userData.id));
        setStep(1);
      } else if (codeSendResponse == 403) {
        setErrorState({
          error: true,
          message: "Incorrect code.",
        });
      }
    } catch (err) {
      console.log(err);
      setErrorState({
        error: true,
        message: "Error while verifying code.",
      });
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="70vh"
      textAlign="center"
    >
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={"Email Verified successfully"}
      />
      <Typography
        sx={{
          fontWeight: "400",
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "Inter-Bold",
        }}
      >
        Email Verification
      </Typography>
      <Typography variant="body1" mb={3}>
        Please verify your email address to continue.
      </Typography>

      {!codeSent ? (
        <SecondaryBtn
          text="Get Code"
          noIcon
          width={"30%"}
          onClick={handleSendCode}
        />
      ) : (
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <CustomInput
            placeholder="Enter Code"
            noIcon
            value={verificationCode}
            width={"30%"}
            setValue={setVerificationCode}
            sx={{ textAlign: "center" }} // Ensures text inside is centered
          />
          <CustomBtn
            text="Verify"
            noIcon
            width={"30%"}
            onClick={handleVerify}
            disabled={!verificationCode}
            sx={{ marginTop: 2 }}
          />
        </Box>
      )}
    </Box>
  );
};

export default EmailVerification;
